export function InstagramSocialBar() {
  return (
    <a
      href="https://www.instagram.com/sepps.fitness/"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Sepp's Fitness auf Instagram"
      className="fixed group z-20 no-underline
        hidden md:flex md:w-auto md:right-[var(--page-margin)] md:bottom-8 md:flex-row md:items-center md:gap-3"
    >
      {/* Linie oben (mobile) / links (desktop) */}
      <span className="block md:hidden w-[1px] h-6 bg-white/30 group-hover:bg-primary transition-colors duration-300 shrink-0" />

      {/* Instagram Icon */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-[18px] h-[18px] md:w-5 md:h-5 text-white/60 group-hover:text-primary transition-colors duration-300 shrink-0"
      >
        <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" stroke="none" />
      </svg>

      {/* Text – nur Desktop */}
      <span className="hidden md:block text-[11px] uppercase tracking-[0.25em] text-white/50 group-hover:text-primary transition-colors duration-300 font-medium whitespace-nowrap">
        Folge uns auf Instagram
      </span>

      {/* Linie unten (mobile) / rechts (desktop) */}
      <span className="block md:hidden w-[1px] h-6 bg-white/30 group-hover:bg-primary transition-colors duration-300 shrink-0" />
    </a>
  );
}
